/**
 * cf-dev-platform-p00f deck — metadata only.
 *
 * Eagerly loaded by the public-index card grid and the admin Studio listing.
 * Slides + components are lazy-loaded via `loadDeckBySlug(slug)` only when
 * someone visits `/decks/cf-dev-platform-p00f`.
 *
 * Frame: showcase the Cloudflare Developer Platform first, then use the
 * real, deployed, open-source p00f app as the worked example that
 * exercises it end to end. The deck sells the platform, not the app.
 */
import type { DeckMeta } from "@/framework/viewer/types";

export const meta: DeckMeta = {
  slug: "cf-dev-platform-p00f",
  title: "Building an end-to-end application on the Cloudflare Developer Platform",
  description:
    "A tour of the Cloudflare Developer Platform, told through one real open-source app: Workers, Durable Objects, R2, Turnstile, and Workers Builds, live at p00f.me.",
  date: "2026-06-25",
  author: "Miguel Caetano Dias",
  event: "Peer Point Manchester 2026",
  tags: ["developer-platform", "workers", "durable-objects", "r2", "live-demo"],
  runtimeMinutes: 22,
};
